module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
(function (fox) {
	'use strict';

	var Promise = fox.Promise;
	var result = null;

	function checker (ctx) {
		var _this = ctx;

		return function () {
			var api1 = _this.getApi('checkGetStarted', {
				method: 'Liveshow.getStarted',
				sendTimezone: true
			});
			var api2 = _this.getApi('content.get', {
				method: 'content.load',
				cacheChannel: 'content'
			});

			function checkLiveshowGetStarted () {
				return new Promise(function (resolve) {
					api1.psend({
						random: Math.random()
					}).then(function (resp) {
						var res = fox.objectGet(resp, 'params.answer.response') || {};

						return resolve(fox.inArray(['inited', 'next_liveshow'], fox.objectGet(res, 'success.status')) ||
							!!(res.id && res.sign));
					}).catch(function () {resolve(false);});
				});
			}

			function checkLiveshowRecorded () {
				return new Promise(function (resolve) {
					api2.psend({
						transitParameters: {preset: 'recordedLiveshows'}
					}).then(function (resp) {
						return resolve(fox.objectGet(resp, 'params.answer.response.isExists'));
					}).catch(function () {resolve(false);});
				});
			}
			
			return result === null && Promise.all([
				checkLiveshowGetStarted(),
				checkLiveshowRecorded()
			]).then(function (results) {
				result = results.some(function (res) {
					return res;
				});

				return result;
			}) || result;
		};
	}

	var id = fox.uniqid();
	var handlerAlias = 'handleWom.onInited' + id;
	var options = {};

	options[handlerAlias] = {
		event: 'running',
		widget: '@this',
		'params.prefix': 'menuChecker' + id,
		callback: function () {
			this.addChecker('liveshowChecker', checker(this), true);

			this.handleEvent('@root #socket', 'inboxSocketEventLiveshow:connect', function () {
				result = null;

				return this.runAsyncCheckers()
					.then(this._rebuildMenu.bind(this));
			}.bind(this), {prefix: 'invalidateResult'});
		}
	};

	fox.registerOptions('~.Menu_Main', options, 1, {});
})(fox);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/widget/menu/checkers/liveshow.js
// module id = 883
// module chunks = 4